import { useRef } from 'react';
import styles from './Footer.module.css';

/**
 * 5개 페이지 공통 푸터.
 * 구성: ①정책 링크바(개인정보처리방침·이용약관·TOP) ②사업자정보 + 로고/슬로건 ③저작권 + SNS
 * SNS 링크는 실제 채널 URL이 연결되어 있어 정상 이동한다. href가 "#"인 placeholder만
 * 클릭 시 "현재 준비 중입니다." 토스트를 보여주도록 원본 동작을 그대로 유지했다.
 */
export default function Footer() {
  const toastTimer = useRef(null);
  const toastRef = useRef(null);

  const handleSnsClick = (e, href) => {
    if (href !== '#') return;
    e.preventDefault();
    const toast = toastRef.current;
    if (!toast) return;
    toast.classList.add(styles.show);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => {
      toast.classList.remove(styles.show);
    }, 1800);
  };

  return (
    <>
      <footer className={styles.siteFooter}>
        <div className={styles.footPolicy}>
          <div className="wrap">
            <a href="/privacy" className={styles.strong}>
              개인정보처리방침
            </a>
            <a href="/terms">이용약관</a>
            <a
              href="#top"
              className={styles.footTop}
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <span className={styles.arw}>↑</span>TOP
            </a>
          </div>
        </div>

        <div className="wrap">
          <div className={styles.footMain}>
            <div className={styles.footOrg}>
              <img src="/assets/visang_cut.png" alt="비상교육" className={styles.footVisangLogo} />
              <div className={styles.footBiz}>
                경기도 과천시 과천대로2길 54 그라운드브이 | 대표자명 양태회
                <br />
                사업자등록번호 : 113-85-35627 | 통신판매업신고번호 : 제 2024-경기과천-0103호
              </div>
            </div>
            <div className={styles.footBrand}>
              <img src="/assets/logo_en_footer.png" alt="English POP" className={styles.footLogo} />
              <p className={styles.tag}>
                즐겁게 시작하고 습관으로 성장하는 영어
                <br />
                비상교육이 만든 6~9세 영어 프랜차이즈, 잉글리시팝
              </p>
            </div>
          </div>

          <div className={styles.footBottom}>
            <span className={styles.footCopy}>© 비상교육 2026. All Rights Reserved.</span>
            <div className={styles.footSns}>
              <a
                href="https://www.youtube.com/@visangenglishpop"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                onClick={(e) => handleSnsClick(e, 'https://www.youtube.com/@visangenglishpop')}
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23 7.5a3 3 0 0 0-2.1-2.1C19 5 12 5 12 5s-7 0-8.9.4A3 3 0 0 0 1 7.5 31 31 0 0 0 .6 12 31 31 0 0 0 1 16.5a3 3 0 0 0 2.1 2.1C5 19 12 19 12 19s7 0 8.9-.4a3 3 0 0 0 2.1-2.1A31 31 0 0 0 23.4 12 31 31 0 0 0 23 7.5zM9.8 15.3V8.7l5.7 3.3z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/visangenglishpop/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                onClick={(e) => handleSnsClick(e, 'https://www.instagram.com/visangenglishpop/')}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                </svg>
              </a>
              <a
                href="https://blog.naver.com/englishpop_"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="블로그"
                onClick={(e) => handleSnsClick(e, 'https://blog.naver.com/englishpop_')}
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 5h16v11H8l-4 4z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>

      <div ref={toastRef} className={styles.snsToast} role="status" aria-live="polite">
        현재 준비 중입니다.
      </div>
    </>
  );
}
